/*Геттеры*/
import * as names from "store/names";

const getters = {
  [names.CONNECTED]: (state) => state.connected,
};
export { getters };
